module.exports = __webpack_public_path__ + "static/leaving-a-mark-in-the-marvel-universe-895777820cadc1353b12b6dc70bf7e60.jpg";